module.exports = __webpack_public_path__ + "pexels-ketut-subiyanto-4546145 shaded - cropped.png?1737d753c11f1f8e8c8e3141e2d47337";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/pexels-ketut-subiyanto-4546145 shaded - cropped.png
// module id = 60
// module chunks = 0